// Auth
export const AUTH_LOGIN_URL = 'auth/login'
export const AUTH_LOGIN_ERROR = 'AUTH_LOGIN_ERROR'
export const AUTH_LOGIN_LOADING = 'AUTH_LOGIN_LOADING'
export const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS'

export const AUTH_LOGOUT_LOADING = 'AUTH_LOGOUT_LOADING'
export const AUTH_LOGOUT_SUCCESS = 'AUTH_LOGOUT_SUCCESS'
